module.controller('bankTransferCtrl', ['$scope', '$rootScope', 'cacheService', '$filter', '$state', '$stateParams', '$http', 'baseURI', 'Transform', 'Session', 'OVERLAY','scheduleRecurringService', 'bankToAddService', function ($scope, $rootScope, cacheService, $filter, $state, $stateParams, $http, baseURI, Transform, Session, OVERLAY,scheduleRecurringService, bankToAddService){
  var url = baseURI + 'bank/transfer';
  var createRecurringUrl = baseURI + 'bank/transfer/auto';
  var transferType = $stateParams.transferType;

  $scope.alert = {};
  $scope.alert.alertMessage = 'Sorry, we were unable to process the bank transfer at this time.  If you continue to experience this issue, please call customer service ' + $scope.brand.programContactPhone + '.';

  $scope.isExpense = Session.getExpense();
  $scope.transferType = transferType;
  $scope.attempted = false;
  $scope.overlay = (transferType == 'load' ? OVERLAY['member.home.bank/load'] : OVERLAY['member.home.bank/withdraw']);
  $scope.sourceLabel = (transferType == 'load' ? 'Select Source' : 'Select Destination');
  $scope.formData = {};

  var getBanks = function (){
    $http.get(baseURI + 'bank?Username=' + encodeURIComponent($stateParams.username), {cache: true}).then(function (resp){
      if(resp.data.Data !== null){
        $scope.sources = resp.data.Data;
        selectAddedAccount(resp.data.Data);
      }
    });
  };

  if(transferType == 'withdraw'){
    $scope.limits = Session.getLimits()['BNK-TRN-OUT'];
  } else {
    $scope.limits = Session.getLimits()['BNK-TRN-IN'];
  }

  $scope.amountValid = false;
  $scope.amountMessage = null;
  $scope.balance = $rootScope.balance;

  $scope.attemptSubmission = function (formData){
    if(formData.$valid && $scope.amountValid){
      $scope.lowFunds = false;
      $scope.alert.errorShown = false;
      $state.go('member.home.bank/transfer.step2', {transferType: transferType});
    } else {
      $scope.alert.errorShown = true;
      $scope.attempted = true;
    }
  };

  $scope.processForm = function (formData){
    $scope.loading = true;

    if($scope.formData.makeRecurring == 'on' && $scope.formData.datePicker.dateSelect.formattedDate != 'Today'){
      scheduleRecurringTransaction(function(err, data){
        $scope.loading = false;
        if(err){

        } else {
          $state.go('member.home.bank/transfer.confirmation', {transferType: transferType});
          $scope.direction = ($scope.transferType == 'load' ? 'To' : 'From');
          $scope.alert.successShown = true;
          $scope.alert.successMessage = 'You have set up a bank transfer';
          $scope.alert.successShown = true;
        }
      });
    } else {
      transfer();
    }
  };

  // Adds context to the amount messaging
  $scope.formatAmountMessage = function(){
    var amount = $scope.formData.Amount;
    var balance = $scope.balance;
    var volumeLimit = ($scope.limits && $scope.limits.volume) || null;

    if(amount){
      if (amount > balance && transferType == 'withdraw'){
        $scope.amountValid = false;
        $scope.amountMessage = 'Oops, there\'s not enough on your ' + $scope.brand.commonProgramName + '.';
      }
      else if (volumeLimit && amount > volumeLimit){
        $scope.amountValid = false;
        $scope.amountMessage = 'Oops, looks like the current limit today is ' + $filter('akimboCurrency')(volumeLimit, '$') + '.';
      }
      else {
        $scope.amountValid = true;
        $scope.amountMessage = 'Sweet. We\'re ready to ' + (transferType == 'withdraw' ? 'withdraw to': 'load from') + ' your bank.';
      }
    } else {
      $scope.amountValid = false;
      $scope.amountMessage = null;
    }
  };

  $scope.$watch('formData.Source', $scope.formatAmountMessage);

  // watch makeRecurring value;
  // if this is the first time a ch updates it, show the calendar
  $scope.$watch('formData.makeRecurring', function(newValue, oldValue){
    if(newValue == 'on' && oldValue === undefined){
      $scope.formData.showScheduleOption = true;
    }
  });

  $scope.isInstantTransfer = function(bankData) {
    if ($scope.transferType == 'load' && bankData) {
      getPostDate();
      return (bankData.InstantTransfersActive && bankData.InstantTransfersEligible);
    } else {
      return false;
    }
  };

  $scope.isStandardTransfer = function(bankData) {
    if ($scope.transferType == 'load' && bankData) {
      getPostDate();
      return (!bankData.InstantTransfersActive || !bankData.InstantTransfersEligible);
    } else {
      return false;
    }
  };

  $scope.isBankSelected = function(bankData) {
    if ($scope.transferType == 'load' && bankData) {
      return true;
    } else {
      return false;
    }
  };

  var getPostDate = function() {

    moment.tz.add("America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5");

    var postDate;
    // Time-zone
    var tz = 'America/Chicago';
    // 7:30 pm of today
    var todayThreshold = moment().clone().tz(tz).hours(19).minutes(23).seconds(0);
    // Now
    var startDate = moment().clone().tz(tz);

    // Check if Now is after 7:30 pm
    if ( startDate.isAfter(todayThreshold) ) {
      // If it's later than 7:30 pm, change startDate to tomorrow
      startDate = moment().clone().add(1, 'days').tz(tz);
    }

    switch (startDate.weekday()) {
      case 1: // Monday
      case 2: // Tuesday
        postDate = startDate.clone().add(3, 'days');
        break;
      case 3: // Wednesday
      case 4: // Thursday
      case 5: // Friday
      case 6: // Saturday
        postDate = startDate.clone().add(5, 'days');
        break;
      case 0: // Sunday
        postDate = startDate.clone().add(4, 'days');
        break;
    }

    $scope.postDateFormatted = postDate.tz(tz).format('MM/DD/YYYY');

  };


  var transfer = function(){
    var request = {
      Amount: $scope.formData.Amount,
      BankAccountId: $scope.formData.Source.Id,
      TransferType: (transferType == 'load' ? 'in' : 'out')
    };

    $http({
      method: 'POST',
      url: url,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: Transform.encode(request)
    }).then(function(resp){
      var data = resp.data;

      $scope.loading = false;
      if(data.Success){

        if($scope.formData.makeRecurring == 'on')
          scheduleRecurringTransaction();


        cacheService.clear(transferType);
        $state.go('member.home.bank/transfer.confirmation', {transferType: transferType});

        $scope.alert.successMessage = 'You have set up a bank transfer';
        $scope.alert.successShown = true;
      } else {
        //$scope.transferError = true;
        $scope.alert.alertShown = true;
      }
    }).catch(function (error){
      $scope.loading = false;
      $scope.alert.alertShown = true;
    });
  };


  var scheduleRecurringTransaction = function(cb){
    var startDate = ($scope.formData.datePicker.dateSelect.formattedDate == 'Today' ?
        $scope.formData.dateOptions[1].formattedDate :
        $scope.formData.datePicker.dateSelect.formattedDate);

    var scheduleRequest = {
      BankAccountId: $scope.formData.Source.Id,
      TransferType: (transferType == 'load' ? 'in' : 'out'),
      Amount: $scope.formData.Amount,
      StartDate: startDate,
      FrequencyType: $scope.formData.datePicker.frequency.key,
      FrequencyDay1: $scope.formData.datePicker.day1.key,
      FrequencyDay2: $scope.formData.datePicker.day2.key
    };

    // set schedule via service
    scheduleRecurringService.set({url: createRecurringUrl}, scheduleRequest)
        .then(function(data){
          if(cb)
            cb(null, data);
        }).catch(function(err){
      if(cb)
        cb(err);
    });
  };

  getBanks();

  function selectAddedAccount(accounts) {
    var accountsAdded = bankToAddService.getAccounts();
    var accountsAddedNames = [];

    for (var accountAdded in accountsAdded) {
      accountsAddedNames.push(accountsAdded[accountAdded].Name);
    }

    for (var account in accounts) {
      for (var i = 0; i < accountsAddedNames.length; i++) {
        if (accountsAddedNames[i] == accounts[account].Name) {
          $scope.formData.Source = accounts[account];
        }
      }
    }
  }
}]);
